import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
import '../styles/fonts.css';

const testimonials = [
{
  id: 1,
  name: 'Daughter of Resident, Toronto',
  role: ' ',
  // image:'https://images.unsplash.com/photo-1735424080768-8730f9c8a0e9?w=150&h=150&fit=crop',
  image: '/images/client1.jpeg',
  content: 'After joining Restorative Connections, my mother began walking again with confidence. She smiles more and participates in group activities — something we never thought possible.',
  rating: 5
  
},
{
  id: 2,
  name: 'Resident',
  role: '78 years old',
  // image:'https://images.unsplash.com/photo-1700878032566-6114a7c1119a?w=150&h=150&fit=crop',
  image: '/images/client2.jpeg',
  content: 'The therapists treat every person with kindness and respect. They truly restore not only strength but dignity.',
  rating: 5
}
];


export default function TestimonialsCarousel() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);

  const slideVariants = {
    enter: (direction) => ({
      x: direction > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction) => ({
      x: direction < 0 ? 300 : -300,
      opacity: 0
    })
  };

  const paginate = (newDirection) => {
    setDirection(newDirection);
    setCurrent((prev) => (prev + newDirection + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const timer = setInterval(() => paginate(1), 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}>

          <span className="text-emerald-600 pt-10 text-sm font-medium uppercase tracking-wider">TESTIMONIALS</span>
          <h2 className="text-4xl md:text-5xl kaushan-script font-bold text-gray-900 mt-3 mb-6">
            Stories of <span className="text-emerald-600">Transformation</span>
          </h2>
          <p className="text-gray-600 text-med max-w-4xl fuzzy-bubbles mx-auto">
            Real experiences from real people who have embarked on their Restorative Therapy journey with us.
          </p>
        </motion.div>

        <div className="relative max-w-4xl mx-auto">
          {/* Main Carousel */}
          <div className="relative h-[400px] md:h-[320px] overflow-hidden">
            <AnimatePresence initial={false} custom={direction} mode="wait">
              <motion.div
                key={current}
                custom={direction}
                variants={slideVariants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{ duration: 0.5, ease: "easeInOut" }}
                className="absolute inset-0">

                <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100 h-full">
                  <Quote className="text-[#e99807] mb-6 lucide lucide-quote w-12 h-12" />
                  
                  <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-8 italic">
                    "{testimonials[current].content}"
                  </p>

                  <div className="flex items-center justify-between flex-wrap gap-4">
                    <div className="flex items-center gap-4">
                      <img
                        src={testimonials[current].image}
                        alt={testimonials[current].name}
                        className="w-14 h-14 rounded-full object-cover ring-4 ring-emerald-100" />

                      <div>
                        <h4 className="font-semibold text-gray-900">{testimonials[current].name}</h4>
                        <p className="text-gray-500 text-sm">{testimonials[current].role}</p>
                      </div>
                    </div>
                    <div className="flex gap-1">
                      {[...Array(testimonials[current].rating)].map((_, i) =>
                      <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
                      )}
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={() => paginate(-1)}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-700 hover:text-emerald-600 hover:shadow-xl transition-all">

            <ChevronLeft size={24} />
          </button>
          <button
            onClick={() => paginate(1)}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-700 hover:text-emerald-600 hover:shadow-xl transition-all">

            <ChevronRight size={24} />
          </button>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) =>
            <button
              key={index}
              onClick={() => {
                setDirection(index > current ? 1 : -1);
                setCurrent(index);
              }}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === current ?
              'w-8 bg-gradient-to-r from-emerald-500 to-teal-500' :
              'bg-gray-300 hover:bg-gray-400'}`
              } />

            )}
          </div>
        </div>
      </div>
    </section>);

}